// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————— EVENT HANDLERS ———————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import eh_addBtn_click from "../eventHandlers/eh_addBtn_click.js";

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const loggerMsgs = {
  initStart: ["init. addBtn"],
  initSuccess: ["init. addBtn", "init. success"],
  noValidDOMEl: ["init. addBtn", "no valid DOM element provided"],
};

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function init_addBtn() {
  // Setup...
  const { addBtn } = this.ref;
  let logArgs = { eventName: "init_addBtn", inline: true };
  this.logger("init", loggerMsgs.initStart, "action", logArgs);

  // Guard...
  if (addBtn === undefined || !this.validate_refEl(addBtn)) return this.cancel_featInit(loggerMsgs.noValidDOMEl);

  // Listen to click events on add-btn...
  addBtn.addEventListener("click", eh_addBtn_click.bind(this));

  // Conclude...
  this.logger("init", loggerMsgs.initSuccess, "success", logArgs);
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
